<template>
  <router-view />
</template>

<script setup>
</script>

<style lang="scss">
#app {
  width: 100%;
  min-height: 100%;
  background: $bg;
  color: $text;
}
</style>
